// @flow
import gql from 'graphql-tag.macro';
import { useMutation } from '@apollo/react-hooks';
import type { MutationTuple } from '@apollo/react-hooks';

export const MUTATION_SAVE_RETAILER_PREFERENCES = gql`
  mutation saveRetailerPreferences(
    $retailerPreferencesInput: RetailerPreferencesInput!
  ) {
    saveRetailerPreferences(retailerPreferencesInput: $retailerPreferencesInput) {
      language
    }
  }
`;

export const useMutationSaveRetailerPreferences = ({
  onCompleted,
  onError,
}: QueryVariables): MutationTuple<any, any> => {
  return useMutation(MUTATION_SAVE_RETAILER_PREFERENCES, {
    onError,
    onCompleted,
  });
};
